
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/igem",
      function () {
        return require("private-next-pages/igem/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/igem"])
      });
    }
  